import { DetailDescriptionDataSource } from '../DetailDescriptionDataSource';
import { AssetType } from '../../../api/models/Shared.types';
import { Backend } from '../../../api/Backend';
import { ISeriesV5 } from '../../../api/models/AndromeTV.types';
import { IDetailDescription } from '../detail.types';

export class EpgSeriesDetailDescriptionDataSource extends DetailDescriptionDataSource {
  private series: ISeriesV5;

  constructor(seriesId: string | undefined, seriesAsset: ISeriesV5, backend: Backend) {
    super(seriesId, AssetType.SERIES, backend);
    this.series = seriesAsset;
  }

  override load(): Promise<IDetailDescription> {
    const res: IDetailDescription = {
      title: this.series.text.title,
      synopsis: this.series.text.longDescription ?? this.series.text.shortDescription ?? '',
      ageRating: undefined,
      score: undefined,
      metaInformation: undefined,
      expire: undefined,
      subscription: undefined,
      pricing: undefined,
      resolution: undefined,
      secondaryMetaInfo: undefined,
      credits: undefined,
      parentalControlIcons: undefined,
      bookmarkPercentage: undefined,
    };
    return Promise.resolve(res);
  }
}
